import { LayoutEditorShell } from '../../../lib/form-layout/LayoutEditorShell';
import {
  ENTRY_FORM_FIELDS,
  ENTRY_FORM_FIELD_NAMES,
  ENTRY_DEFAULT_LAYOUT,
  type EntryFormContext,
} from '../../../lib/form-layout/entry-fields';
import {
  useAdminActiveEntryLayout,
  useUpdateEntryFormLayout,
} from '../../../queries/entry-form-layout';
import { useDocumentTypes } from '../../../queries/document-types';
import { useProspectsList } from '../../../queries/prospects';
import type { EntryInputSchema } from '../../../lib/schemas';

/**
 * Thin wrapper around LayoutEditorShell that wires the entry-form's
 * registry / queries / preview context.
 */
export function EntryFormLayoutEditor() {
  const { data: docTypes = [] } = useDocumentTypes();
  const { data: prospects = [] } = useProspectsList({ limit: 500 });

  // Pre-populate the preview's `has_mineral_reservation` so the conditional
  // description field shows in the live preview (admins want every placeable
  // field visible in the preview, regardless of values).
  const previewDefaults: EntryInputSchema = {
    title_run_id: '00000000-0000-0000-0000-000000000000',
    document_type_id: null,
    prospect_id: null,
    instrument_date: null,
    recording_date: null,
    book: null,
    page: null,
    instrument_number: null,
    legal_description: null,
    consideration: null,
    interest_conveyed: null,
    depth_limitation: null,
    area_limitation: null,
    reservations: null,
    township: null,
    range: null,
    section: null,
    block: null,
    abstract: null,
    survey: null,
    has_mineral_reservation: true,
    mineral_reservation_description: null,
    remarks: null,
    reviewer_notes: null,
  };

  const previewContext: EntryFormContext = { docTypes, prospects };

  return (
    <LayoutEditorShell
      title="Entry form layout"
      breadcrumbLabel="Entry form layout"
      registry={ENTRY_FORM_FIELDS}
      allNames={ENTRY_FORM_FIELD_NAMES}
      defaultLayout={ENTRY_DEFAULT_LAYOUT}
      useActive={useAdminActiveEntryLayout}
      useUpdate={useUpdateEntryFormLayout}
      previewDefaults={previewDefaults}
      previewContext={previewContext}
    />
  );
}
